<template>
  <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
    <b-card class="standardpage reports invoices border-none">
      <div class="availtable datatable text-left">
        <b-card-body class="py-0">
          <!-- {{ item.reason }} -->
          <!-- {{ requirement }} -->
          <b-tabs class="gridtabs">
            <b-tab :active="true">
              <template #title>
                <div class="badgecontainer pr-5">
                  <i :class="options.icon" class="text-primary mr-1"></i>
                  <span class="text-center badgenormal badge-secondary badge-pill">
                    {{ item.referenceno }}
                  </span>
                  <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit_V2"
                  }}&gt;</span>
                </div>
              </template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Payment Method" label-for="card" label-cols="12">
                      <treeselect instanceId="card" type="number" v-model="item.payby" :clearable="false"
                        :options="payby_options" :disabled="readonly"></treeselect>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group :label="$helpers.requiredlabel(requirement, 'Payment Method Reason')" :class="$helpers
                      .requiredlabel(requirement, 'Payment Method Reason')
                      .slice(0, 1) == '*'
                      ? 'text-danger'
                      : ''
                      " label-for="paymethodreason" label-cols="12">
                      <!-- <b-form-group label="Payment Method Reason" label-for="card" label-cols="12"> -->
                      <treeselect instanceId="card" type="number" v-model="item.paybyreason" :clearable="false"
                        :options="paybyreason_options" :disabled="$helpers
                          .requiredlabel(requirement, 'Payment Method Reason')
                          .slice(0, 1) == '*' ? false : true"></treeselect>
                    </b-form-group>
                  </b-col>
                  <!-- <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Booking Type" label-for="reason" label-cols="12" size="sm">
                      <treeselect instanceId="reason" type="number" v-model="item.reason" :clearable="false"
                        :options="reason_options" :disabled="readonly"></treeselect>
                    </b-form-group>
                  </b-col> -->
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group :label="$helpers.requiredlabel(requirement, 'Deployment Id')" :class="$helpers
                      .requiredlabel(requirement, 'Deployment Id')
                      .slice(0, 1) == '*'
                      ? 'text-danger'
                      : ''
                      " label-for="deploymentid" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.deploymentid" placeholder="Enter deploymentid" size="sm"
                          :disabled="readonly"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.deploymentid = ''"
                            :disabled="readonly">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Issued Date" label-size="sm">
                      <b-input-group>
                        <daterangepicker size="sm" ref="date" v-model="mapper_date" :opens="'right'"
                          :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true"
                          :linkedCalendars="true" :single-date-picker="'true'" :disabled="true">
                        </daterangepicker>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="true" @click="item.date = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <!-- <b-col cols="12" sm="6" md="4" xl="3">
  <b-form-group label-cols="12" :label="$helpers.requiredlabel(requirement, 'Date Travel')" :class="$helpers
    .requiredlabel(requirement, 'Date Travel')
    .slice(0, 1) == '*'
    ? 'text-danger'
    : ''
    " label-size="sm">
   
    <b-input-group>
      <b-input-group-prepend>
        <b-form-datepicker size="sm" v-model="item.datetravel" :disabled="readonly" button-only label-help=""
          hide-header locale="en-GB"></b-form-datepicker>
      </b-input-group-prepend>
      <b-form-input size="sm" id="date" v-model="item.datetravel" :disabled="readonly" type="text"
        placeholder="YYYY-MM-DD" autocomplete="off"></b-form-input>
      <b-input-group-append>
        <b-button size="sm" variant="outline-secondary" :disabled="readonly" @click="item.datetravel = null">
          <i class="fa fa-remove"></i>
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </b-form-group>
</b-col> -->
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group :label="$helpers.requiredlabel(requirement, 'Event')" :class="$helpers.requiredlabel(requirement, 'Event').slice(0, 1) == '*'
                      ? 'text-danger'
                      : ''
                      " label-for="event" label-cols="12">
                      <treeselect placeholder="Select event..." searchPromptText="Type at least 4 chars..."
                        v-model="item.event" :clearable="true" :async="true" :load-options="treeselect_loadEvent"
                        :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true"
                        :matchKeys="['id']" :disabled="readonly" search-nested>
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" :label="$helpers.requiredlabel(requirement, 'Date Travel')" :class="$helpers
                      .requiredlabel(requirement, 'Date Travel')
                      .slice(0, 1) == '*'
                      ? 'legend-text-danger'
                      : ''
                      " label-size="sm">
                      <b-input-group>
                        <daterangepicker class="w-auto" size="sm" ref="datetravel" v-model="mapper_datetravel"
                          :opens="'right'" :locale-data="locale_data" :ranges="false" :showDropdowns="true"
                          :single-date-picker="'true'">
                        </daterangepicker>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="false"
                            @click="mapper_datetravel = { startDate: null, endDate: null }">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                    <!-- <span class="mt-0 small text-primary"
    v-html="mapper_datetravel.startDate ? $moment(mapper_datetravel.startDate).valueOf().toString() : null"></span> -->
                  </b-col>

                </b-row>

                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" :label="$helpers.requiredlabel(requirement, 'Supplier B/L')" :class="$helpers
                      .requiredlabel(requirement, 'Supplier B/L')
                      .slice(0, 1) == '*'
                      ? 'text-danger'
                      : ''
                      " label-size="sm">
                      <treeselect placeholder="Select blac..." searchPromptText="Type at least 3 chars..."
                        v-model="item.blac" :clearable="true" :async="true" :load-options="treeselect_loadBLAC"
                        :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true"
                        :matchKeys="['id']" :disabled="blac_disabled" search-nested>
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Supplier Type Override" label-size="sm">
                      <b-input-group class="treeselect_all" style="left:118px; top:-13px">
                        <i id="suppliertype" class="fa fa-info-circle text-black"></i>
                      </b-input-group>
                      <b-tooltip target="suppliertype" triggers="hover" placement="top">
                        Only available when Supplier B/L is one of MKAMEX, MRBAAMEX, MWBAAMEX, NWBAAMEX, WBAMEX,
                        BCARDCONF,
                        BCARDTP, SVPCONF,TPWSREC
                      </b-tooltip>
                      <!-- <treeselect placeholder="Select booking type..." searchPromptText="Booking Type..."
                        v-model="item.reason" :clearable="true" :options="options_suppliertype">                        
                      </treeselect>-->
                      <treeselect placeholder="Supplier B/L type override" instanceId="reason" type="number"
                        v-model="item.reason" :clearable="true" :options="options_suppliertype"
                        :disabled="disabled_supplytype">
                      </treeselect>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Payment Amount GBP" label-for="amount" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.value" placeholder="Enter amount GBP" size="sm"
                          lazy-formatter :formatter="nocomma" :disabled="readonly"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.value = '0.00'"
                            :disabled="readonly">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Currency" label-for="currency" label-cols="12" label-size="sm">
                      <treeselect instanceId="currency" type="number" v-model="item.currency" :clearable="false"
                        :options="currency_options" :disabled="readonly"></treeselect>
                    </b-form-group>
                  </b-col>
                  <!-- <b-col cols="12" sm="6" md="4" xl="3">
  <b-form-group label="Country" label-for="country" label-cols="12" label-size="sm">
    <treeselect instanceId="country" type="number" v-model="item.country" :clearable="false"
      :options="country_options" :disabled="readonly"></treeselect>
  </b-form-group>
</b-col> -->


                </b-row>
                <!-- {{ item }} -->
                   <!-- / MUST Inlcude ALL Conferma transaction IDs -->
                <b-row>
                  <b-col cols="9" sm="9">
                    <b-form-group :label="$helpers.requiredlabel(
                      requirement,
                      'Details'
                    )
                      " :class="$helpers
                        .requiredlabel(
                          requirement,
                          'Details'
                        )
                        .slice(0, 1) == '*'
                        ? 'text-danger'
                        : ''
                        " label-for="data" label-cols="12">
                      <b-form-textarea id="data" v-model="item.comments" placeholder="Details" rows="8" max-rows="8"
                        class="smalltextarea" :disabled="readonly"></b-form-textarea>
                    </b-form-group>
                  </b-col>
                  <b-col cols="3" sm="3">
                    <b-card class="py-0 h6 text-primary border-none">
                      <div class="mb-2">
                        <i class="fa fa-bullhorn fa-2x text-danger mr-2"></i>
                        Wait, have you added?
                      </div>
                      <b-card-text class="h6">
                        <b-row class="mt-1">
                          <b-col cols="auto">
                            <i class="fa fa-check-square-o text-danger mr-1"></i>
                          </b-col>
                          <b-col cols="auto"> Travel Dates </b-col>
                        </b-row>
                        <b-row class="mt-1">
                          <b-col cols="auto">
                            <i class="fa fa-check-square-o text-danger mr-1"></i>
                          </b-col>
                          <b-col cols="auto"> Routing </b-col>
                        </b-row>
                        <b-row class="mt-1">
                          <b-col cols="auto">
                            <i class="fa fa-check-square-o text-danger mr-1"></i>
                          </b-col>
                          <b-col cols="auto"> Airline </b-col>
                        </b-row>
                        <b-row class="mt-1">
                          <b-col cols="auto">
                            <i class="fa fa-check-square-o text-danger mr-1"></i>
                          </b-col>
                          <b-col cols="auto"> Traveller Name </b-col>
                        </b-row>
                        <b-row class="mt-1">
                          <b-col cols="auto">
                            <i class="fa fa-check-square-o text-danger mr-1"></i>
                          </b-col>
                          <b-col cols="auto"> Conferma transaction IDs </b-col>
                        </b-row>
                        <b-row class="float-right mt-3">
                          <b-col cols="auto"> Don't get unsubmitted!</b-col>
                          <b-col cols="auto">
                            <i class="fa fa-reply fa-2x text-danger mr-1"></i>
                          </b-col>
                        </b-row>
                      </b-card-text>
                    </b-card>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" :label="$helpers.requiredlabel(requirement, 'Client SL A/C')" :class="$helpers
                      .requiredlabel(requirement, 'Client SL A/C')
                      .slice(0, 1) == '*'
                      ? 'text-danger'
                      : ''
                      " label-size="sm">
                      <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..."
                        v-model="item.slac" :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                        :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true"
                        :matchKeys="['id']" :disabled="readonly" search-nested>
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3" v-if="mifields.length == 0">
                    <b-form-group :label="$helpers.requiredlabel(requirement, 'Your Ref/PO')" :class="$helpers
                      .requiredlabel(requirement, 'Your Ref/PO')
                      .slice(0, 1) == '*'
                      ? 'text-danger'
                      : ''
                      " label-for="yourref" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.yourref" placeholder="Enter your ref" size="sm"
                          :disabled="readonly"></b-form-input>

                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.yourref = ''"
                            :disabled="readonly">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Price to Client GBP" label-for="charge" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.charge" placeholder="Enter price GBP" size="sm"
                          lazy-formatter :formatter="nocomma" :disabled="readonly"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.charge = '0.00'"
                            :disabled="readonly">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3" v-if="mifields.length == 0">
                    <b-form-group label="Booker Name" label-for="bookername" label-cols="12" size="sm">
                      <treeselect instanceId="bookername" type="text" v-model="bookerinit" :clearable="false"
                        :options="options_bookernames"></treeselect>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row align-v="end" class="nopadding my-2 mt-4 background-transparent" no-gutters>
                  <b-col cols="12" class="text-left text-orange mt-n2 divider ">
                    MI Fields
                  </b-col>
                </b-row>

                <!-- {{ mifields }} -->
                <b-row v-if="mifields.length > 0">
                  <b-col cols="12" sm="6" md="4" xl="3" v-for="(mifield, index) in mifields" :key="index">
                    <!-- <b-form-group :label="label(mifield)" label-cols="12" label-size="sm">-->
                    <b-form-group :label="$helpers.requiredlabel(requirement, mifield.label)" :class="$helpers
                      .requiredlabel(requirement, mifield.label)
                      .slice(0, 1) == '*'
                      ? 'text-danger'
                      : ''
                      " label-cols="12" label-size="sm">
                      <b-input-group>
                        <!-- :placeholder="placeholder(mifield)" :debounce="mifields.debounce" -->
                        <!-- v-model="mifields.args[mifield.key]"  -->
                        <b-form-input v-if="mifield.type == 'input'" type="text" :disabled="mifield.active == '0'"
                          size="sm" trim v-model="mifield.value" :placeholder="mifield.label"></b-form-input>

                        <!-- v-if="mifield.clearable" @click="mifields.args[mifield.key] = null"-->
                        <b-input-group-append v-if="mifield.type == 'input'" @click="mifield.value = ''">
                          <b-button size="sm" variant="outline-secondary">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>

                      <!-- && filter.options
                      :multiple="filter.multiple == true ? true : false" -->
                      <!-- v-model="mifield.args[mifield.key]" :placeholder="mifield.placeholder"-->
                      <treeselect v-if="mifield.type == 'listofvalues'" :show-count="true"
                        :flatten-search-results="true" :clearable="false" :disable-branch-nodes="true"
                        :matchKeys="['id']" search-nested :options="mifield.options" v-model="mifield.value">
                      </treeselect>

                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row v-if="mifields.length == 0">
                  <b-col>
                    There are no fields to display
                  </b-col>
                </b-row>

                <b-row v-if="permissionvalid('systems.development')" class="mt-3">
                  <b-col cols="12" sm="12">
                    <b-form-group label="Tags" label-for="tags" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.tags" placeholder="Tags" size="sm" :disabled="readonly"
                          trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" :disabled="readonly" variant="outline-secondary" @click="item.tags = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- {{ requirement }} -->
                <b-row class="my-2"><b-col><span class="text-danger small">* Required</span></b-col></b-row>
              <div v-if="user.permissions.includes('bookingforms.admin') && idselected != null">
                <div class="innerborder px-2 pt-1">
                  <b-row>
                    <b-col cols="12" sm="12">
                      <b-form-group label="Message" label-for="data" label-cols="12">
                        <b-form-textarea id="data" v-model="item.message" placeholder="Message to Agent" rows="6"
                          class="smalltextarea"></b-form-textarea>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Agent" label-for="agent" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.agent" placeholder="Enter agent"
                            size="sm"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.agent = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="InvoiceNo" label-for="invoiceno" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.invoiceno" placeholder="Enter invoiceno"
                            size="sm"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.invoiceno = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Status" label-for="data" label-cols="12">
                        <b-form-radio-group id="higlight" v-model="item.status" :options="[
                          { text: 'Submitted', value: 'submitted' },
                          { text: 'Unsubmitted', value: 'unsubmitted' },
                        ]" buttons button-variant="outline-success" size="sm" name="radio-btn-outline">
                        </b-form-radio-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Resend Mail ?" label-for="data" label-cols="12">
                        <b-form-radio-group id="mailagain" v-model="item.mailagain" :options="[
                          { text: 'Yes', value: 'true' },
                          { text: 'No', value: 'false' },
                        ]" buttons button-variant="outline-success" size="sm" name="radio-btn-outline">
                        </b-form-radio-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
              </div>
              </p>
            </b-tab>

            <b-tab v-if="idselected">
              <template #title>
                <i class="fa fa-history text-primary mr-1"></i> Audit
              </template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="ID" label-for="id" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.id" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.id = ''" :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <!-- <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Submitted At" label-for="submitted_at" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.submitted_at" button-only label-help=""
                            locale="en-GB" :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.submitted_at" type="text"
                          placeholder="YYYY-MM-DD" autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.submitted_at = null"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Submitted By" label-for="submitted_by" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.submitted_by" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.submitted_by = ''"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col> -->
                </b-row>
                <b-row>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Created At" label-for="created_at" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.created_at" button-only label-help=""
                            locale="en-GB" :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.created_at" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.created_at = null"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Created By" label-for="created_by" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.created_by" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.created_by = ''"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.updated_at" button-only label-help=""
                            locale="en-GB" :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.updated_at" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.updated_at = null"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.updated_by" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.updated_by = ''"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </p>
            </b-tab></b-tabs>
        </b-card-body>
        <b-card-footer class="mt-2 mx-2 px-0">
          <b-row no-gutters>
            <b-col cols="4" class="text-left">
              <b-row>
                <b-col cols="auto">
                  <b-button squared size="sm" variant="primary" v-if="savevisible" :disabled="savedisabled"
                    @click="saveit()">
                    <i class="fa fa-check"></i>
                    Save It
                  </b-button>
                </b-col>
                <b-col class="pt-1">
                  <div v-if="busy">
                    <i class="fa fa-spinner fa-spin text-primary"></i>
                  </div>
                  <div v-else>
                    <span v-html="message"></span>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="4" class="text-center">
              <b-button class="ml-1" size="sm" variant="info" @click="submit()" squared v-if="submitvisible">
                <i class="fa fa-paper-plane"></i>
                Submit To Accounts
              </b-button>
            </b-col>

            <!-- v-if="!config" -->
            <b-col cols="4" class="text-right">
              <b-button squared size="sm" variant="secondary" @click="discard">
                <i class="fa fa-chevron-left pr-1"></i>
                Back
              </b-button>
            </b-col>
          </b-row>
          <!-- {{ requirement }} {{ this.mifields.length }} -->
        </b-card-footer>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "BookingFormEdit",

  async mounted() {

    try {
      const response = await this.$apollo.query({
        query: gql`
            query setup_bookingformspaytypes($active:String) {
              setup_bookingformspaytypes(active: $active) {
                id: code
                label
                blac
                reasonrequired
              }
            }
          `,
        variables: { active: "1" }
      });
      this.payby_options = response.data.setup_bookingformspaytypes;
    } catch (error) {
      console.log(error);
    }

    try {
      const response = await this.$apollo.query({
        query: gql`
            query setup_bookingformspayreasons {
              setup_bookingformspayreasons {
                id: code
                label
              }
            }
          `,
      });
      this.paybyreason_options = response.data.setup_bookingformspayreasons;
    } catch (error) {
      console.log(error);
    }

    try {
      const response = await this.$apollo.query({
        query: gql`
            query setup_currencies {
              setup_currencies {
                id:code
                label
              }
            }
          `,
      });
      this.currency_options = response.data.setup_currencies;
    } catch (error) {
      console.log(error);
    }

    try {
      const response = await this.$apollo.query({
        query: gql`
            query bookingformsreasontypes {
              bookingformsreasontypes {
                id
                label: name
              }
            }
          `,
      });
      this.reason_options = response.data.bookingformsreasontypes;
    } catch (error) {
      console.log(error);
    }

    try {
      const response = await this.$apollo.query({
        query: gql`
            query suppliertypes {
              suppliertypes {
                id
                label
              }
            }
          `,
      });
      this.options_suppliertype = response.data.suppliertypes;
    } catch (error) {
      console.log(error);
    }

    if (!this.requirement.blac) {
      this.requirement.blac = "Supplier B/L"
    }
    //  / MUST Inlcude ALL Conferma transaction IDs
    if (!this.requirement.comments) {
      this.requirement.comments = "Details"
    }
    if (!this.requirement.slac) {
      this.requirement.slac = "Client SL A/C"
    }
    if (!this.requirement.datetravel) {
      this.requirement.datetravel = "Date Travel"
    }
    if (!this.requirement.event) {
      this.requirement.event = "Event"
    }
    if (!this.item.agent) {
      this.item.agent = this.user.initials;
    }
  },
  data() {
    return {
      busy: false,
      mapper_date: {
        startDate: this.$moment().format("YYYY-MM-DD HH:mm"),
        endDate: this.$moment().format("YYYY-MM-DD HH:mm"),
      },
      mapper_datetravel: {
        startDate: null,
        endDate: null,
      },
      payby_options: [],
      paybyreason_options: [],
      blac_disabled: false,
      reason_options: [],
      // country_options: [],
      currency_options: [],
      options_bookernames: [],
      options_suppliertype: [],
      bookerinit: null,
      item: {
        id: null,
        referenceno: null,
        date: this.$moment().valueOf().toString(),
        datetravel: null,
        reason: null,
        payby: "BANK",
        paybyreason: null,
        value: "0.00",
        deploymentid: null,
        currency: "GBP",
        // country: "GB",
        comments: null,
        blac: null,
        slac: null,
        event: null,
        charge: "0.00",
        invoiceno: null,
        yourref: null,
        agent: null,
        status: "unsubmitted",
        mailagain: "false",
        tags: "{}",
      },
      options: {
        title: "Booking Form Edit",
        icon: "fa fa-tasks",
      },
    };
  },

  watch: {
    mapper_date: {
      async handler(newVal, oldVal) {
        if (newVal) {
          this.item.date = this.$moment(newVal.startDate).valueOf().toString()
        }
      }
    },
    mapper_datetravel: {
      async handler(newVal, oldVal) {
        if (newVal) {
          if (newVal.startDate) {
            this.item.datetravel = this.$moment(newVal.startDate).valueOf().toString()
          } else {
            this.item.datetravel = null
          }
        }
      }
    },
    "item.slac": {
      // deep: true,
      immediate: true,
      async handler(newVal, oldVal) {
        await this.load_mifields("true");
        console.log("watch:item.slac", newVal, this.mifields.length);

        if (newVal) {
          let attributes = await this.$helpers.loadSLACAttributes(newVal);

          if (this.mifields.length == 0) {
            if (attributes.includes("/PO")) {
              this.$set(this.requirement, "yourref", "Your Ref/PO");
            } else {
              this.$delete(this.requirement, "yourref");
            }
          }

          await this.load_bookerinitials();

        }
      },
    },
    "item.payby": {
      async handler(newVal, oldVal) {
        console.log("watch:item.payby", newVal);
        if (newVal.includes("CONF")) {
          this.$set(this.requirement, "deploymentid", "Deployment Id");
        } else {
          this.$delete(this.requirement, "deploymentid");
        }
        console.log(this.requirement);
        let payby = this.payby_options.find(o => o.id == newVal)
        console.log('newblac', payby)
        // this.item.blac = null
        this.blac_disabled = false
        if (payby) {
          if (payby.blac) {
            // if (!this.item.blac) {
            this.item.blac = payby.blac
            this.blac_disabled = true
            // }
          }
        }
        if (payby) {
          if (payby.reasonrequired == "1") {
            this.$set(this.requirement, "paybyreason", "Payment Method Reason");
          } else {
            this.item.paybyreason = null
            this.$delete(this.requirement, "paybyreason");
          }
        }
      },
    },
    "item.blac": {
      async handler(newVal, oldVal) {
        console.log("watch:item.blac", newVal);
        if (this.item.reason) { return}
        let attributes = await this.$helpers.loadBLACAttributes(newVal);
        if (!this.item.reason) {
          this.item.reason = attributes
        }
        switch (this.item.blac) {
          case "MKAMEX":
          case "MRBAAMEX":
          case "MWBAAMEX":
          case "NWBAAMEX":
          case "WBAMEX":
          case "BCARDCONF":
          case "BCARDTP":
          case "SVPCONF":
          case "TPWSREC":
            break;
          default:
            this.item.reason = attributes

        }
      }
    },
    "item.reason": {
      async handler(newVal, oldVal) {
        console.log("watch:item.reason", newVal);
        await this.load_mifields("true");
      },
    },
  },
  computed: {
    submitvisible() {
      let result = false;
      if (this.item.status == "unsubmitted") {
        if (this.item.agent == this.user.initials) {
          result = true;
        }
      }
      if (this.user.permissions.includes("bookingforms.admin")) {
        result = true;
      }
      return result;
    },
    savevisible() {
      let result = false;
      if (this.item.status == "unsubmitted") {
        result = true;
      }
      if (this.user.permissions.includes("bookingforms.admin")) {
        result = true;
      }
      return result;
    },
    savedisabled() {
      let result = true;
      if (this.item.agent == this.user.initials) {
        result = false;
      }
      if (this.user.permissions.includes("bookingforms.admin")) {
        result = false;
      }
      return result;
    },
    disabled_supplytype() {
      let result = true
      if (!this.item.blac) { return true }
      switch (this.item.blac) {
        case "MKAMEX":
        case "MRBAAMEX":
        case "MWBAAMEX":
        case "NWBAAMEX":
        case "WBAMEX":
        case "BCARDCONF":
        case "BCARDTP":
        case "SVPCONF":
        case "TPWSREC":
          result = false
          break;
      }
      if (this.item.payby == 'INVO') {
        result = false
      }
      return result
    },
    readonly() {
      let result = true;
      if (this.item.status == "unsubmitted") {
        if (this.item.agent == this.user.initials) {
          result = false;
        }
      }
      if (this.user.permissions.includes("bookingforms.admin")) {
        result = false;
      }
      return result;
    },
  },
  methods: {
    // async load_mifields() {

    //   let tags = this.item.tags == null ? null : JSON.parse(this.item.tags)
    //   this.mifields = [];

    //   let variables = {
    //     slac: this.item.slac,
    //     active: "1",
    //   };
    //   const response = await this.$apollo.query({
    //     query: gql`
    //                 query setup_mifields($slac: String, $active: String) {
    //                 setup_mifields(slac: $slac, active: $active) {
    //                     key
    //                     type
    //                     label
    //                     options
    //                     required
    //                     value
    //                     active
    //                 }
    //                 }
    //             `,
    //     variables,
    //   });
    //   this.mifields = response.data.setup_mifields;
    //   for (var i = 0; i < this.mifields.length; i++) {
    //     this.mifields[i].value = null
    //     if (this.mifields[i].options) {
    //       this.mifields[i].options = JSON.parse(this.mifields[i].options)
    //     }
    //     if (this.mifields[i].required == "1") {
    //       this.requirement[this.mifields[i].key] = this.mifields[i].label;
    //     }
    //   }
    //   // FIND CORRECT OPTION IN LIST REGARDLESS OF CASE
    //   for (var prop in tags) {
    //     let found = this.mifields.find(o => o.key == prop);
    //     if (found) {
    //       if (found.options) {
    //         let ddvalue = found.options.find(o => o.id.toLowerCase() == tags[prop].toLowerCase());
    //         if (ddvalue) {
    //           found.value = ddvalue.id
    //         } else {
    //           found.value = tags[prop];
    //         }
    //       } else {
    //         found.value = tags[prop];
    //       }
    //     }
    //   }
    // },

    async load_bookerinitials() {
      if (!this.item.slac) {
        this.options_bookernames = [];
        return;
      }

      let variables = {
        slac: this.item.slac,
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_bookerinitials($slac: String) {
              setup_bookerinitials(slac: $slac) {
                id: initials
                label
              }
            }
          `,
          variables,
        });
        this.options_bookernames = response.data.setup_bookerinitials;
      } catch (error) {
        console.log(error);
      }
      if (this.item.yourref) {
        try {
          let yrparts = this.item.yourref.split("*");
          if (yrparts.length > 1) {
            this.bookerinit = yrparts[1];
          }
        } catch (error) {
          console.log(error);
        }
      }
    },

    async load() {
      let variables = {
        mssql: true,
        id: this.idselected,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query bookingforms($mssql:Boolean, $id: String, $dateformat: String) {
              bookingforms(mssql: $mssql, id: $id, dateformat: $dateformat) {
                id
                referenceno
                payby
                paybyreason
                blac
                reason
                date
                datetravel
                value
                deploymentid
                currency
                # country
                comments
                event
                slac
                charge
                invoiceno
                yourref
                agent
                status
                message
                tags
                # submitted_at
                # submitted_by
                created_at
                created_by
                updated_at
                updated_by
              }
            }
          `,
          variables,
        });

        if (response.data.bookingforms.length > 0) {
          this.item = response.data.bookingforms[0];

          let unixdate = null
          unixdate = this.$moment.unix(this.item.date / 1000).utc(true).format("YYYY-MM-DD HH:mm")
          this.mapper_date = { startDate: unixdate, endDate: unixdate }
          unixdate = this.$moment.unix(this.item.datetravel / 1000).utc(true).format("YYYY-MM-DD")
          this.mapper_datetravel = { startDate: unixdate, endDate: unixdate }

          let payby = this.payby_options.find(o => o.id == this.item.payby)
          if (payby) {
            if (payby.reasonrequired == "1") {
              this.$set(this.requirement, "paybyreason", "Payment Method Reason");
            } else {
              this.item.paybyreason = null
              this.$delete(this.requirement, "paybyreason");
            }
          }


          if (this.config.action == "copy") {
            this.item.id = null;
            this.item.referenceno = null;
            this.item.invoiceno = null;
            this.item.status = "unsubmitted";
            this.item.agent = this.user.initials;
          }

        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async saveit() {
      this.busy = true;

      if (this.mapper_datetravel.startDate) {
        this.item.datetravel = this.$moment(this.mapper_datetravel.startDate).valueOf().toString()
      } else {
        this.item.datetravel = null
      }

      let rows = [this.cleanit(this.item)];

      let requirements = "";
      for (var prop in this.requirement) {
        if (prop.slice(0, 3) != 'mi_') {
          if (rows[0][prop] == null) {
            requirements += this.requirement[prop] + ",";
            break;
          }
        }
      }
      requirements += await this.mifields_requirement()

      console.log("requirements", requirements);
      if (requirements.length > 0) {
        this.message =
          "<span class='text-danger'>" +
          requirements.slice(0, -1) +
          " required field(s). </span>";
        this.busy = false;
        return;
      } else {
        this.message = ""
      }

      if (this.item.slac == "BBC3" && this.item.yourref) {
        let yrparts = this.item.yourref.split("*");
        if (yrparts.length != 2) {
          this.message =
            "<span class='text-danger'>Your Ref/PO" +
            " needs a Booker Name (e.g. " +
            this.item.yourref +
            "*RE)</span>";
          if (!this.user.permissions.includes("bookingforms.admin")) {
            this.busy = false;
            return;
          }
        }
      }

      if (this.mifields.length > 0) {
        let tags = JSON.parse(this.item.tags || "{}");
        for (var k = 0; k < this.mifields.length; k++) {
          tags[this.mifields[k].key] = this.mifields[k].value;
        }
        // rows[0].tags = JSON.stringify(tags);
      }

      let variables = { rows };

      if (this.config.action == "copy") {
        variables.rows[0].id = null;
        variables.rows[0].referenceno = null;
        variables.rows[0].invoiceno = null;
        variables.rows[0].status = "unsubmitted";
        variables.rows[0].agent = this.user.initials;
      }

      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation bookingforms_save(
              $rows: [Bookingform_input]
            ) {
              bookingforms_save(rows: $rows) {
                id
                referenceno
                payby
                #reason
                date
                datetravel
                blac
                #value
                #deploymentid
                #currency
                #country
                #comments
                event
                slac
                #charge
                invoiceno
                yourref
                message
                agent
                status                
              }
            }
          `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";

        this.$emit("refresh");
        this.$emit("discard");
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;

      this.$store.dispatch("bookingforms")
    },
    async submit() {
      this.busy = true;

      let rows = [this.cleanit(this.item)];
      rows[0].status = "submitted";
      rows[0].mailagain = "true";

      let requirements = "";
      for (var prop in this.requirement) {
        if (prop.slice(0, 3) != 'mi_') {
          if (rows[0][prop] == null) {
            requirements += this.requirement[prop] + ",";
            break;
          }
        }
      }
      requirements += await this.mifields_requirement()

      console.log("requirements", requirements);
      if (requirements.length > 0) {
        this.message =
          "<span class='text-danger'>" +
          requirements.slice(0, -1) +
          " required field(s). </span>";
        this.busy = false;
        return;
      } else {
        this.message = ""
      }

      if (this.item.slac == "BBC3" && this.item.yourref) {
        let yrparts = this.item.yourref.split("*");
        if (yrparts.length != 2) {
          this.message =
            "<span class='text-danger'>Your Ref/PO" +
            " needs a Booker Name (e.g. " +
            this.item.yourref +
            "*RE)</span>";
          if (!this.user.permissions.includes("bookingforms.admin")) {
            this.busy = false;
            return;
          }
        }
      }

      let variables = { rows };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation bookingforms_save(
              $rows: [Bookingform_input]
              $dateformat: String
            ) {
              bookingforms_save(rows: $rows, dateformat: $dateformat) {
                id
                referenceno
                payby
                #reason
                date
                datetravel
                blac
                #value
                #deploymentid
                #currency
                #country
                #comments
                event
                slac
                #charge
                invoiceno
                yourref
                agent
                status
              }
            }
          `,
          variables,
        });

        this.message = "<span class='text-primary'>Submitted it.</span>";

        // DONT FORGET THIS TO HIDE THE BUTTON
        this.item.status = "submitted";

        this.$emit("refresh");
        this.$emit("discard");
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }
      this.busy = false;

      this.$store.dispatch("bookingforms")
    },

  },
};
</script>

<style></style>